module.exports = __webpack_public_path__ + "img/symbol_2.70d82432.png";